import React, { useEffect } from 'react';
import { Popup } from '@/components/common/Popup/Popup';
import { LoginStandAlone } from '@/features/auth/LoginStandAlone/LoginStandAlone';
import styles from './LoginModal.module.scss';
import { ELoginProvidersViewType } from '@/models';
import { useAnalytics } from '@/hooks/analytics/useAnalytics';
import { ANALYTICS } from '@/constants/analytics/analytics';

interface ILoginModalProps {
  onClose: () => void;
  source: string;
}
export const LoginModal: React.FC<ILoginModalProps> = (
  props: ILoginModalProps
) => {
  const { fireAnalyticsEvent } = useAnalytics();

  useEffect(() => {
    fireAnalyticsEvent(ANALYTICS.EVENTS.AUTHENTICATION_MODAL, {
      [ANALYTICS.PROPERTIES.EVENT_TYPE]: ANALYTICS.TYPES.SHOWN,
      [ANALYTICS.PROPERTIES.SCREEN]: ANALYTICS.EVENTS.AUTHENTICATION_MODAL,
      [ANALYTICS.PROPERTIES.SOURCE]: props.source,
    });
  }, []);

  return (
    <Popup onClose={props.onClose}>
      {({ close }) => (
        <div className={styles.loginModal}>
          <LoginStandAlone
            analyticsPayload={{ source: props.source }}
            showTitles={true}
            onSuccess={close}
            providersViewType={ELoginProvidersViewType.vertical}
          />
        </div>
      )}
    </Popup>
  );
};
